import MyPage from '../../../../subjects/Page';
import { PAGE_CELL_HEIGHT } from '@/subjects/constant';
/**
 * 题目基类
 */
export default class TopicBasic {
  static maxHeight = PAGE_CELL_HEIGHT;
  static maxwidth = 706;
  width = 706;
  height = PAGE_CELL_HEIGHT;
  canDrag = true;
  page = new MyPage();
  constructor({ width, height, canDrag }) {
    this.width = width || 706;
    this.height = height || PAGE_CELL_HEIGHT;
    this.canDrag = canDrag || true;
  }

  toString() {
    return '(' + this.width + ', ' + this.height + ',' + this.canDrag + ')';
  }
}
